export default "__VITE_ASSET__DVgfIwHu__"